export type QRValidationFunction = (qrData: string) => string | false;

/** Used for decommissioned device types that can no longer be registered. */
export const decommissionedDeviceRegistration: QRValidationFunction = () => false;

export const saplingQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:(0004A30B00[a-f0-9A-F]{6}):(0000|FFFF)(00|10|11)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        return false;
    }
    return "eui-" + match[1].toLowerCase();
};

export const sproutMicroQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:(0004A30B00[a-f0-9A-F]{6}):(0000|FFFF)(00|20)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        // Support reprogrammed sapling devices
        return saplingQRCodeValidation(QR);
    }
    return "eui-" + match[1].toLowerCase();
};

export const sproutBlockQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:(0004A30B00[a-f0-9A-F]{6}):(0000|FFFF)(00|21)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        return false;
    }
    return "eui-" + match[1].toLowerCase();
};

export const gen4BlockQRCodeValidation: QRValidationFunction = (QR: string) => {
    const match = QR.match(/LW:D0:[0-9a-fA-F]{16}:([a-f0-9A-F]{16}):(FFFF)(31)[a-f0-9A-F]{2}/);
    if (!match || !match[1]) {
        return false;
    }
    return "eui-" + match[1].toLowerCase();
};
